/* eslint-disable no-useless-catch */
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
// import { toast } from "ToastAlertContainer";

const deletePost = async ({ companyId, postId }) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(
    `/api/v2/companies/${companyId}/posts/${postId}`,
    pathAndHost
  );

  let deletePost;
  try {
    deletePost = await axios.delete(url);
  } catch (err) {
    console.error(err.response.data);
    throw err;
  }

  return deletePost.data;
};

export default function useDeletePost() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ companyId, postId }) =>
      await deletePost({
        companyId,
        postId,
      }),
    {
      onMutate: async ({ companyId, postId }) => {
        await queryClient.cancelQueries(["companies", companyId, "posts"]);

        const previousPostsResult = queryClient.getQueryData(
          ["companies", companyId, "posts"],
          { exact: false }
        );

        let previousPosts = previousPostsResult.data;

        let optimisticPosts = previousPosts.filter((post) => {
          if (post.post_id !== postId) {
            return true;
          } else {
            return false;
          }
        });

        queryClient.setQueryData(
          ["companies", companyId, "posts"],
          optimisticPosts
        );

        return {
          previousPosts,
          optimisticPosts,
          companyId,
        };
      },
      onError: (err, Post, context) => {
        queryClient.setQueryData(
          ["companies", context.companyId, "posts"],
          context.previousPosts
        );
      },
      onSettled: (deletedPost) => {
        let companyId = deletedPost.company_id;

        queryClient.invalidateQueries(["companies", companyId, "posts"]);
      },
    }
  );
}
